import i18n from '@/i18n'
import { success, danger } from '@/lib/notification'

export const checkState = field => {
    return field.$dirty ? !field.$invalid : null
}

export const operationSuccessfullySnotification = operation => {
    const item = i18n.t('careerObjective.careerObjective')
    if (operation === 'create') {
        return success(
            i18n.t('notification.createdSuccessfully', {
                item,
            })
        )
    }

    if (operation === 'update') {
        return success(
            i18n.t('notification.editedSuccessfully', {
                item,
            })
        )
    }

    return success(
        i18n.t('notification.deletedSuccessfully', {
            item,
        })
    )
}

export const notificationError = () => {
    danger()
}
